import React from 'react';
import { useScope } from 'ia-react-core';
import Resource from '../../Resource/Resource';
import getContestApiRoot from '../../../utils/getContestApiRoot';
import { ContestInformation } from '../../../interfaces/ContestInformation';
import { ContestResourceInfo } from '../ContestResource/ContestResource';

const UnsubscribeResource = () => {
  const { getScopedState } = useScope();
  const contest: ContestInformation = getScopedState(ContestResourceInfo.dataDst);
  if (!contest) return null;

  return (
    <Resource
      name="/App.contest.unsubscribeResource"
      method="DELETE"
      url={`${getContestApiRoot()}/${contest.promoterCode}/participants/self`}
    />
  );
};

export default UnsubscribeResource;
